import { Component, Input, OnInit } from '@angular/core';
import { DailyData, IntegratorSetting, MonthlyData } from '@dmonitor/shared/response/sensor/integrator';
import { BaseComponent } from '@dmonitor/shared/index';
import { ToastController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DeviceType } from '../..';
import { DeviceColors } from '@dmonitor/sensors/sensors.type';

@Component({
  selector: 'integrator-monthlydatagraph',
  templateUrl: 'monthlydatagraph.component.pug',
  styleUrls: ['monthlydatagraph.component.sass'],
})
export class MonthlyDataGraphComponent extends BaseComponent implements OnInit {
  protected TRANSLATE_KEY: string = "page.equipment.integrator.dailydata.graph";
  @Input() MonthlyData: MonthlyData[] = [];
  @Input() Settings: IntegratorSetting;
  showXAxis = true;
  showYAxis = true;
  xAxisLabel = '';
  yAxisLabel = '';
  graphData = null;
  colorScheme = {
    domain: [DeviceColors.COLD_GRAPH_COLOR]
  };
  constructor(
    toastController: ToastController,
    loadingController: LoadingController,
    translateService: TranslateService) {
    super(toastController, loadingController, translateService);
  }
  public ngOnInit(): void {
    this.xAxisLabel = this.translate('xlabel');
    this.yAxisLabel = this.translate('ylabel');
    if(this.Settings.device_type == DeviceType.HOT_WATER){
      this.colorScheme = {
        domain: [DeviceColors.HOT_GRAPH_COLOR]
      };    
    }
    setTimeout(() => {
      this.graphData = this.MonthlyData.reverse().map(d => ({
        name: d.month.replace("-",".").replace("-","."),
        value: d.v == null ? "0" : d.v
      }));

    }, 100);
  }
}